import ActionCardContainer from './ActionCardContainer';
import ActionCardUI from './ActionCardUI';
var ActionCard = {
    Container: ActionCardContainer,
    UI: ActionCardUI
};
export default ActionCard;
